import { ActivatedRoute } from '@angular/router';
import { Component, NgZone, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { Subscription, forkJoin } from 'rxjs';
import { CustomTooltipComponent } from '../core/custom-tooltip/custom-tooltip.component';
import { NgxSpinnerService } from 'ngx-spinner';
import { ExcelService } from '../services/excel.service';
import { OrderExcelServiceService } from '../order-excel-service.service';
import { GriddataService } from '../services/griddata.service';
import { filter } from 'rxjs/operators';
import { ChangeDetectorRef } from '@angular/core';
import * as moment from 'moment';

import {
  MatLegacyDialog as MatDialog,
  MatLegacyDialogConfig as MatDialogConfig,
} from '@angular/material/legacy-dialog';

import { OSPStateService } from '../services/osp-state.service';
import { dateFilterComparator, resetSortingAndFilters, warningMessage, successMessage } from '../constants';
import { logErrors } from '../shared/logger';
import * as mm from 'moment-timezone';

import { RowNode, GroupCellRendererParams, RowGroupingDisplayType } from 'ag-grid-community';
import { AirfreightApicallsService } from '../services/air-freight-validation/airfreight-apicalls.service';
import { LookupService } from '../services/lookup/lookup.service';
import { NavigationEnd, NavigationStart, Router } from '@angular/router';
import { ValidationService } from '../services/air-freight-validation/validations.service';
import { DataServiceService } from '../services/air-freight-validation/data-service.service';
import { ProcurementService } from '../services/procurement/procurement.service';
import { DefaultService } from '../services/default.service';

@Component({
  selector: 'app-procurement',
  templateUrl: './procurement.component.html',
  styleUrls: ['./procurement.component.scss'],
})
export class ProcurementComponent implements OnInit, OnDestroy {
  namcValue = localStorage.getItem('namcvalue');
  count = 0;
  rowData = [];
  rowData1 = [];
  originalRowData = [];
  @ViewChild('osPartsGrid') osPartsGrid;
  isView: boolean = false;
  currentYearWeek: string = '';
  private isInitialized = false;
  columnDefsMaster;
  columnDefs;
  columnDefs1;
  columnDefs2;
  kanbanValue: string = '';
  partValue: string = '';
  dockValue: string = '';
  shareValue: string = '';
  description: string = '';
  specialistValue: any = '';
  seqAddress: any = '';
  orderlotValue: any = '';
  easternCurrentDate = String(mm().tz('US/Michigan').format('YYYY-MM-DD')).substring(0, 10);
  selectedDate: any;
  lineoff_date_start: string = '';
  lineoff_date_end: string = '';
  highlightedField: string = '';
  inventoryPolice: string = '';

  // columnDefsTemp;
  public defaultColDef;
  rowSelection;
  user: string;
  userRole: any;
  warningMessage = '';
  offset: number = 0;
  dataCount: number = 0;
  successMessage = '';
  canceledRecord: any = [];
  isShowArrived: boolean = false;
  isShowCanceled: boolean = false;

  autoGroupColumnDef;
  groupRowsSticky;
  groupDefaultExpanded = 1;
  showOpenedGroup = false;
  groupSelectsChildren;
  suppressRowClickSelection;
  suppressAggFuncInHeader;
  public groupDisplayType: RowGroupingDisplayType = 'singleColumn';
  dataFromSecond: any;
  private orderDataSubscription: Subscription;
  private orderEditDataSubscription: Subscription;

  actionOptions = [{ action_name: 'Devanning History' }, { action_name: 'Container Tap' }];

  selectedAction = '';
  orderDetailsForEdit: any = null;
  for_edit = false;
  for_add_part = false;
  partdata = null;

  gridOptions;
  paginationPageSize;
  paginationNumberFormatter;
  pagination = 'true';
  context: any;
  editType;
  suppressClickEdit = true;
  tooltipShowDelay = 0;
  frameworkComponents = { customTooltip: CustomTooltipComponent };
  onInitVanningFrom: any;
  onInitVanningTo: any;

  editEnabled = false;
  freezeStatus = false;
  filter = false;
  showToggleAll = false;
  showClear = true;
  disablePartNumber: boolean;
  disableKanban: boolean;

  // Dropdowns
  selectedKanban: any = [];
  selectedPartNo: any = [];
  selectedDestCode: any = [];
  selectedContainer: any = [];
  selectedStatus: any = [];
  selectedDock: any = [];
  selectedSpecialist: any = [];
  selectedLifecycle: any = [];
  adjList: any = [];
  selectedAdjlist: any = [];
  addAirOrderPart: any = [];
  addAirOrdereKanban: any = [];
  selectedAircaseCode: any = [];

  vanningFrom: any;
  vanningTo: any;
  adjustSubscription$: Subscription;

  // Dropdown Options
  ordDate: any;
  ordDateTo: any;
  onInitordDate: any;
  onIntordDateTo: any;

  kanbanList: any = [];
  partNoList: any = [];
  destCodeList: any = [];
  containerList: any = [];
  statusList: any = [];
  dockList: any = [];
  specialistList: any = [];
  lifecycleList: any = [];
  rowCount = 0;
  count1 = 0;
  isEditMode = false;
  modalComponent = 'modal-component';
  addGetResponse = [];
  minVanningFrom;
  selectedParts: any = [];
  showHideList: any = [
    {
      label: 'Dock',
      value: 'dock',
    },
    {
      label: 'Air Case Code',
      value: 'air_case_code',
    },
    {
      label: 'Part Number',
      value: 'part_no',
    },

    {
      label: 'Kanban',
      value: 'kanban',
    },
    {
      label: 'Arrival DT',
      value: 'arrival_date',
    },
    {
      label: 'No Of Pieces',
      value: 'number_of_pieces',
    },
    {
      label: 'No Of Lots',
      value: 'number_of_lots',
    },

    {
      label: 'Dest Code',
      value: 'dest_code',
    },
    {
      label: 'Status',
      value: 'air_order_status',
    },
    {
      label: 'Van Center Confirmed',
      value: 'kvc_conf',
    },
    {
      label: 'Van Center ETA DT',
      value: 'vanning_date',
    },
    {
      label: 'Renban',
      value: 'case_no',
    },
    {
      label: 'Order DT',
      value: 'date_raised',
    },
    { value: 'userid', label: 'User' },
    { value: 'date_time', label: 'Updated DT' },
  ];

  selectedShowHideList: any = [...this.showHideList];

  kanbanSelected = 1;

  easternDate: any;
  defaultPageSize: any = 100000;
  kanbanSearchValue: any;
  orderAdded: any;
  gridApi: any;
  pendingOrderData: any;
  pendingOrderEditData: any;
  itContact: string;
  airCaseCode: any = [];
  approvedItems: any;
  namcName: string;
  pmDetails: any = [];
  temp_partList: any = [];
  temp_kanbanList: any = [];
  lineoffDateFrom: any;
  lineoffDateTo: any;
  partsControl: any;
  partsControlGroup: any;
  lineSideAddress: any;
  pcAddress: any;
  lifeCycleCode: any;
  vehicleCode: any;
  storeRackCapacity: any;
  invAdj: string;
  lifeCycle: any;
  filteredData$: Subscription;

  // isEditMode = false;

  constructor(
    private readonly spinner: NgxSpinnerService,
    private readonly excelService: ExcelService,
    private readonly gridDataService: GriddataService,
    public dialog: MatDialog,
    private readonly stateService: OSPStateService,
    private readonly airFreightService: AirfreightApicallsService,
    private readonly procurement: ProcurementService,
    private readonly lookupservice: LookupService,
    private router: Router,
    private dataService: DataServiceService,
    private readonly defaultService : DefaultService
  ) {
    this.context = {
      componentParent: this,
    };
  }
  numberComparator(number1, number2) {
    return number1 - number2;
  }

  onPageSizeChanged() {
    if (this.gridOptions?.api) {
      this.gridOptions.api.paginationSetPageSize(Number(this.paginationPageSize));
    }
  }

  setPageSizeToAll(pageSize?) {
    this.paginationPageSize = this.rowData.length;

    if (pageSize) {
      this.paginationPageSize = 0;
      this.rowData.length = 0;
    }

    this.onPageSizeChanged();
  }

  ngOnDestroy(): void {
    this.adjustSubscription$.unsubscribe();
    if (this.orderDataSubscription) {
      this.orderDataSubscription.unsubscribe();
    }
    if (this.orderEditDataSubscription) {
      this.orderEditDataSubscription.unsubscribe();
    }
    if (this.filteredData$) {
      this.filteredData$.unsubscribe();
      this.orderDetailsForEdit = [];
    }
  }

  ngOnInit(): void {

    //routing from uvr screen
    this.dataService.filteredData$.subscribe((data: any) => {
      if (data) {
        this.selectedParts = data;
      }
    });
    let showData = localStorage.getItem('FromDevan');
    if (showData === 'true') {
      this.filteredData$ = this.dataService.filteredData$.subscribe((data: any) => {
        if (data) {
          this.orderDetailsForEdit = data;
        }
      });
    } else {
      this.orderDetailsForEdit = [];
    }
    localStorage.setItem('FromDevan', 'false');

    const nav = this.router.getCurrentNavigation();
    const state = nav?.extras?.state;

    // this.columnDef1();
    // this.rowData1 = [
    //   { sun_qty: '5', mon_qty: '5', tue_qty: '5', wed_qty: '5', thu_qty: '5', fri_qty: '5', sat: '5', total: '35' },
    //   { sun: '5', mon: '5', tue: '5', wed: '5', thu: '5', fri: '5', sat: '5', total: '35' },
    //   { sun: '10', mon: '10', tue: '10', wed: '10', thu: '10', fri: '10', sat: '10', total: '70' },
    // ];

    //editorderDataSubject

    this.columnDefsMaster = [
      {
        headerName: '',
        sortable: false,
        field: 'approvedItems',
        width: 290,
        pinned: 'left',
        cellRenderer: (params: any) => {
          const index = this.approvedItems[params.node?.rowIndex];
          return `<span>${index}</span>`;
        },
      },
      {
        headerName: 'Sunday',
        autoHeight: true,
        field: 'sun_qty',
        width: 140,
        unSortIcon: true,
        sortable: true,
        cellClassRules: {
          'highlight-day': (params) => this.highlightedField === 'sun_qty',
        },
      },
      {
        headerName: 'Monday',
        autoHeight: true,
        field: 'mon_qty',
        width: 130,
        unSortIcon: true,
        sortable: true,
        cellClassRules: {
          'highlight-day': (params) => this.highlightedField === 'mon_qty',
        },
      },
      {
        headerName: 'Tuesday',
        autoHeight: true,
        field: 'tue_qty',
        width: 130,
        unSortIcon: true,
        sortable: true,
        cellClassRules: {
          'highlight-day': (params) => this.highlightedField === 'tue_qty',
        },
      },
      {
        headerName: 'Wednesday',
        autoHeight: true,
        field: 'wed_qty',
        width: 130,
        unSortIcon: true,
        sortable: true,
        cellClassRules: {
          'highlight-day': (params) => this.highlightedField === 'wed_qty',
        },
      },
      {
        headerName: 'Thursday',
        autoHeight: true,
        field: 'thu_qty',
        width: 130,
        unSortIcon: true,
        sortable: true,
        cellClassRules: {
          'highlight-day': (params) => this.highlightedField === 'thu_qty',
        },
      },
      {
        headerName: 'Friday',
        autoHeight: true,
        field: 'fri_qty',
        width: 130,
        unSortIcon: true,
        sortable: true,
        cellClassRules: {
          'highlight-day': (params) => this.highlightedField === 'fri_qty',
        },
      },
      {
        headerName: 'Saturday',
        autoHeight: true,
        field: 'sat_qty',
        width: 130,
        unSortIcon: true,
        sortable: true,
        cellClassRules: {
          'highlight-day': (params) => this.highlightedField === 'sat_qty',
        },
      },
      {
        headerName: 'Total',
        autoHeight: true,
        field: 'sum_qty',
        width: 140,
        unSortIcon: true,
        sortable: true,
      },
    ];

    this.columnDefs = [...this.columnDefsMaster];
    const approvedItems = ['Production Part Requirements', 'Service Part Requirements', 'Total Part Requirements'];
    this.approvedItems = approvedItems;

    // this.setPageSizeToAll(this.defaultPageSize);

    this.rowSelection = 'multiple';
    this.editType = 'fullRow';
    this.gridOptions = this.gridDataService.getGridOptions();
    this.gridOptions.onGridReady = function (params) {
      this.gridApi = params.api;
    };
    this.adjustSubscription$ = this.stateService.getNamc().subscribe((observable) => {
      this.initializeData();
    });
  }
  // createColumnRendererForField(fieldName: string) {
  //   return {
  //     // Optimized valueGetter to avoid unnecessary operations
  //     valueGetter: (params) => {
  //       if (params.node.group) {
  //         // For group rows, return the value of the first child for the given field
  //         const firstChildData = params.node.allLeafChildren?.[0]?.data;
  //         if (firstChildData) {
  //           return firstChildData[fieldName];
  //         }
  //         return ''; // If no data, return empty string
  //       }
  //       // For child rows, return the value directly
  //       return params.data?.[fieldName] || ''; // Return empty string if field is not available
  //     },

  //     // Optimized cellRenderer: hide the value for group rows and show for child rows
  //     cellRenderer: (params) => {
  //       if (params.node.group) {
  //         return ''; // Instead of returning null, return an empty string
  //       }
  //       // For child rows, show the value of the field
  //       return params.value || ''; // Show the value for child rows
  //     },
  //   };
  // }

  initializeData() {
    this.spinner.show();

    // this.setCurrentYearWeek();
    this.clearValues();

    this.namcValue = localStorage.getItem('namcvalue');

    if (localStorage.getItem('workdayId')) {
      this.user = localStorage.getItem('workdayId');
    }
    this.itContact = localStorage.getItem('itContact');

    if (localStorage.getItem('UserRoles')) {
      this.userRole = localStorage.getItem('UserRoles');
    }
    if (localStorage.getItem('namcName')) {
      this.namcName = localStorage.getItem('namcName');
    }

    this.loadDrop();

    this.onResetDropDown();

    // this.originalRowData = [...this.rowData]; // Keep a copy of the original data

    // this.setPageSizeToAll();
  }
  checkIfAnySelected() {
    console.log("inside",this.selectedKanban,this.selectedPartNo)
    if (
      this.selectedKanban?.length != 0 &&
      this.selectedPartNo?.length != 0 &&
      this.selectedDock?.length !== 0 &&
      this.selectedDate 
    ) {
      return true;
    }

    return false;
  }

  resetGrid() {
    if (this.osPartsGrid) {
      resetSortingAndFilters(this.osPartsGrid);

      return;
    }
  }

  onSearch(offset) {
    this.selectedAction = '';
  
    this.rowData1 = [];
    this.removeMessage();
    this.spinner.show();
    const date = new Date(this.selectedDate);
    // const dayIndex = date.getDay(); // 0 = Sunday, 1 = Monday, etc.
    // console.log(dayIndex)
    // const dayFieldMap = ['sun_qty', 'mon_qty', 'tue_qty', 'wed_qty', 'thu_qty', 'fri_qty', 'sat_qty'];
    // this.highlightedField = dayFieldMap[dayIndex];

    // console.log(this.highlightedField, 'highlightedField');

    const dayIndex = moment(this.selectedDate, 'YYYY-MM-DD').day(); // 0 = Sunday, 1 = Monday, etc.

    const dayFieldMap = ['sun_qty', 'mon_qty', 'tue_qty', 'wed_qty', 'thu_qty', 'fri_qty', 'sat_qty'];
    this.highlightedField = dayFieldMap[dayIndex];

    // Refresh the grid to re-evaluate class rules
    this.gridApi?.refreshCells({ force: true });

    //this.refreshView()
    if (this.osPartsGrid) {
      this.osPartsGrid.gridOptions.api.refreshHeader();

      this.resetGrid();
    }

    if (offset === 0) {
      this.setPageSizeToAll(this.defaultPageSize);
      this.rowData1 = [];
      this.osPartsGrid?.gridOptions?.api.setRowData(this.rowData);
      this.offset = 0;
      this.spinner.show();
    }
    if (!this.checkIfAnySelected()) {
      this.rowData1 = [];
      this.warningMessage = warningMessage.selectdest;

      window.scroll(0, 0);
      this.spinner.hide();
      return false;
    }
    if(!this.selectedKanban){
            this.rowData1 = [];
      this.warningMessage = warningMessage.selectdest;

      window.scroll(0, 0);
      this.spinner.hide();
      return false;


    }

    this.assignWeekDates(this.selectedDate);

    let kanban;
    let selectedPartNo;

    let selectedDock;

    if (this.selectedKanban?.length > 0) {
      if (!this.selectedKanban.some((a) => a.kanban === 'ALL')) {
        kanban = [];
        this.selectedKanban?.forEach((element) => {
          kanban.push(element.kanban);
        });
      }
    }

    if (this.selectedPartNo?.length > 0) {
      if (!this.selectedPartNo.some((a) => a.part_no === 'ALL')) {
        selectedPartNo = [];
        this.selectedPartNo.forEach((element) => {
          selectedPartNo.push(element.part_no);
        });
      }
    }

    const data = {
      business_entity: this.namcValue,
      workid: this.user,
      user_role: this.userRole,
      kanban: this.selectedKanban?.kanban,
      item_id: this.selectedPartNo?.item_id,

      dock: this.selectedDock?.dock,
      namcValue: this.namcName,
      lineoff_date_start: this.lineoff_date_start,
      lineoff_date_end: this.lineoff_date_end,
    };

    this.procurement.getProcurementData(data).subscribe({
      error: (error) => this.errorCallback(error, 'getProcurementData'),
      next: (res) => {
        this.isView = true;
        // Initialize empty rows for each type
        const approvedItems = ['Production Part Requirements', 'Service Part Requirements', 'Total Part Requirements'];
        this.approvedItems = approvedItems;

        const prodRow = { approvedItems: this.approvedItems[0] };
        const serviceRow = { approvedItems: this.approvedItems[1] };
        const totalRow = { approvedItems: this.approvedItems[2] };
        if (res.body && res.body.data?.length > 0) {
          const data = res.body.data[0];

          // Set values
          this.assignValues(data);
          this.spinner.hide();

          res.body.proPartsData.forEach((item: any) => {
            if (item.plan_type === 'VEH') {
              Object.assign(prodRow, item);
            } else if (item.plan_type === 'NVEH') {
              Object.assign(serviceRow, item);
            } else {
              Object.assign(totalRow, item);
            }
          });

          // Set constant approvedItems values AFTER assigning item data
          prodRow.approvedItems = approvedItems[0];
          serviceRow.approvedItems = approvedItems[1];
          totalRow.approvedItems = approvedItems[2];
          // Push in the desired order
          this.rowData1.push(prodRow, serviceRow, totalRow);

          this.osPartsGrid?.gridOptions?.api.setRowData(this.rowData1);

          // this.rowData1.push(...res.body.proPartsData);
          // this.osPartsGrid?.gridOptions?.api.setRowData(this.rowData1);
          // console.log(this.rowData1);
          this.dataCount = parseInt(res.body.data.rowCount);
          const records = this.dataCount - (this.offset + 1) * 12000;
          if (records >= 1) {
            this.offset++;
            this.onSearch(this.offset * 12000);
          } else {
            this.spinner.hide();
          }
        } else {
          this.rowData = [];
          this.spinner.hide();
        }

        this.setPageSizeToAll();
      },
    });
    // return true;
  }

  loadDrop() {
    this.selectedDate = this.easternCurrentDate;

    const lookupSubscriptions = [
      this.lookupservice.getKanban(),
      this.lookupservice.getPartNumber(),
      this.procurement.getDock(),
      this.lookupservice.getqpcforpart(),
    ];
    forkJoin(lookupSubscriptions).subscribe({
      next: (res) => {
        //if kanbanList, add ALL option
        this.kanbanList = [];
        this.partNoList = [];
        this.dockList = [];
        this.temp_kanbanList = [];
        this.temp_partList = [];
        if (res[0].body != 'No Content') {
          //this.kanbanList.push(...res[0].body.data);
          this.temp_kanbanList.push(...res[0].body.data);
        }
        if (res[1].body != 'No Content') {
          //this.partNoList.push(...res[1].body.data);
          this.temp_partList.push(...res[1].body.data);
        }
        if (res[2].body != 'No Content') {
          this.dockList.push(...res[2].body);                
        }
        if (res[3].body != 'No Content') {
          this.pmDetails.push(...res[3].body.data);
        }
        if(this.assignDefaultDock()){
          this.dockChange();
        }
        this.spinner.hide();
      },
      complete: () => {
        if (this.orderDetailsForEdit?.length != 0) {
          this.appendprocurementDetails();
        }

        if (this.selectedParts?.length != 0) {
          this.appendValUvR();
        }
      },

      error: (error) => this.errorCallback(error),
    });

    //   },
    // });
  }
  async appendValUvR() {
    if (this.selectedParts.dock && this.selectedParts.partNo) {
      this.selectedDock = {
        dock: this.selectedParts.dock, // Adjust if needed
      };
      this.dockChange();

      this.selectedPartNo = { item_id: this.selectedParts.partNo };
      this.onPartNoChange();

      await this.onSearch(0);
    }
  }
  errorCallback = (error, apiName = '') => {
    logErrors(error);
    this.spinner.hide();

    let detailedMessage = 'Something went wrong! Please contact support team.';
    let backendMessage = '';
    if (error?.error?.message) {
      backendMessage = error.error.message;
    } else if (error?.message) {
      backendMessage = error.message;
    }
    if (backendMessage) {
      detailedMessage += `| ${backendMessage}`;
    } else if (apiName) {
      detailedMessage += `| Try after some time! Error in ${apiName}`;
    }
    this.warningMessage = detailedMessage;
    // this.rowData = [];
    this.osPartsGrid.gridOptions.api.setRowData(this.rowData);
  };

  onResetDropDown() {
    this.selectedAction = '';

    this.isView = false;
    this.isEditMode = false;
    this.selectedAction = null;

    this.removeMessage();

    this.selectedDestCode = [{ dest_code: 'ALL' }];
    this.selectedKanban = [];
    this.selectedPartNo = [];
    this.selectedDate = this.easternCurrentDate;
    // this.selectedDestCode = [];
    this.selectedContainer = [];
    this.selectedStatus = [];
    this.selectedDock = [];
    this.selectedSpecialist = [];
    this.selectedAdjlist = [];
    this.selectedLifecycle = [];
    this.ordDate = this.onInitordDate;
    this.ordDateTo = this.onInitordDate;
    this.partNoList = [];
    this.kanbanList = [];
    // this.selectedDate = '';
    this.clearValues();
    this.rowData1 = [];
    this.kanbanSearchValue = null;

    if (this.osPartsGrid) {
      this.osPartsGrid.gridOptions.api.refreshHeader();
      this.resetGrid();
    }

    this.setPageSizeToAll(this.defaultPageSize);

    this.rowData = [];
    this.disableKanban = false;
    this.disablePartNumber = false;
    this.offset = 0;
  }

  air_order_columns;
  onShowHideChange(ev: any) {
    this.osPartsGrid.gridOptions.columnApi.setColumnsVisible([...this.showHideList.map((e) => e.value)], true);

    const hideItems = this.showHideList.filter((item) => {
      return !ev.value.map((sItem) => sItem.value).includes(item.value);
    });

    this.osPartsGrid.gridOptions.columnApi.setColumnsVisible([...hideItems.map((e) => e.value)], false);

    if (ev.onInit) return;

    this.air_order_columns = hideItems;
    if (!hideItems.length) this.air_order_columns = [{}];
  }

  // onKanbanChange(): void {
  //   if (this.selectedKanban && this.selectedKanban.kanban) {
  //     this.selectedKanban = {
  //       kanban: this.selectedKanban.kanban,
  //     };

  //     this.disablePartNumber = true;
  //   } else {
  //     this.disablePartNumber = false;
  //   }
  // }

  onKanbanChange(): void {
    if (this.selectedKanban && this.selectedKanban.kanban) {
      this.selectedKanban = {
        kanban: this.selectedKanban.kanban,
      };

      this.disablePartNumber = true;

      const kanbanNo = this.selectedKanban?.kanban;
      const dock = this.selectedDock?.dock;
      const matchingItem = this.pmDetails.find((entry) => entry.kanban === kanbanNo && entry.dock === dock);

      if (matchingItem) {
        this.selectedPartNo = { item_id: matchingItem.item_id };
      } else {
        this.selectedPartNo = null;
      }
    } else {
      this.disablePartNumber = false;
    }
  }

  // onPartNoChange(): void {
  //   if (this.selectedPartNo && this.selectedPartNo.item_id) {
  //     this.selectedPartNo = {
  //       item_id: this.selectedPartNo.item_id,
  //     };

  //     console.log(this.selectedPartNo, 'hi....');

  //     this.disableKanban = true;
  //   } else {
  //     this.disableKanban = false;
  //   }
  // }
  onPartNoChange(): void {
    if (this.selectedPartNo && this.selectedPartNo.item_id) {
      this.selectedPartNo = {
        item_id: this.selectedPartNo.item_id,
      };

      this.disableKanban = true;

      // 💡 New code starts here
      const part_no = this.selectedPartNo?.item_id;
      const dock = this.selectedDock?.dock;

      const matchingItem = this.pmDetails.find((entry) => entry.item_id === part_no && entry.dock === dock);

      if (matchingItem) {
        this.selectedKanban = { kanban: matchingItem.kanban };
        // this.selectedKanban = {
        //   kanban: this.selectedKanban.kanban,
        // };
      } else {
        this.selectedKanban = null;
      }
      // 💡 New code ends here
    } else {
      this.disableKanban = false;
    }
  }

  dockChange(): void {
    // Reset disable flags
    this.disableKanban = false;
    this.disablePartNumber = false;

    this.kanbanList = [];
    this.partNoList = [];

    this.selectedKanban = [];
    this.selectedPartNo = [];

    if (this.selectedDock.length >= 1) {
      this.selectedDock = {
        dock: [this.selectedDock.dock],
      };
    }

    const selectedDockVal = this.selectedDock?.dock;

    if (selectedDockVal) {
      const pmList = this.pmDetails.filter((element) => element.dock === selectedDockVal);

      // Create kanban list without duplicates
      const uniqueKanbans = new Set();
      this.kanbanList = pmList
        .filter((item) => {
          if (!uniqueKanbans.has(item.kanban)) {
            uniqueKanbans.add(item.kanban);
            return true;
          }
          return false;
        })
        .map((item) => ({ kanban: item.kanban }))
        .sort((a, b) => parseInt(a.kanban) - parseInt(b.kanban));

      // Create part number list without duplicates
      const uniqueParts = new Set();
      this.partNoList = pmList
        .filter((item) => {
          if (!uniqueParts.has(item.item_id)) {
            uniqueParts.add(item.item_id);
            return true;
          }
          return false;
        })
        .map((item) => ({ item_id: item.item_id }))
        .sort((a, b) => parseInt(a.item_id) - parseInt(b.item_id));
    }
    this.defaultService.setDockCode(JSON.stringify([{dock : this.selectedDock.dock}]));
  }

  assignDefaultDock(){
    try {
      if (this.dockList?.length > 0){
        const defaultdockArray : any[] = JSON.parse(this.defaultService.getCurrentDockCode());
        if (Array.isArray(defaultdockArray)){
          const validDocks = new Set(defaultdockArray.map(item => item.dock));
          this.selectedDock = this.dockList.find(item => validDocks.has(item.dock));
          if (this.selectedDock){
            return true;
          }
        }
      }
      return false;
    } catch (error) {
      console.log('Error in assigning default dock',error);
      return false;
    }
  }

  adjChange(): void {
    if (this.selectedAdjlist.length >= 1) {
      if (this.selectedAdjlist[this.selectedAdjlist.length - 1].adj_type === 'ALL') {
        this.selectedAdjlist = [];
        this.selectedAdjlist.push(this.adjList[0]);
      } else {
        let indexAll = this.selectedAdjlist.findIndex((data) => data.adj_type === 'ALL');

        if (indexAll > -1) {
          this.selectedAdjlist.splice(indexAll, 1);
        }
      }
    }
  }

  getModifiedRowData(): any {
    return this.rowData.filter((row) => row.rowCheckBox);
  }

  removeMessage() {
    this.warningMessage = '';
    this.successMessage = '';
  }

  getSelectedRowData(): any {
    // Get the selected rows using the grid API
    const selectedNodes = this.gridOptions.api.getSelectedNodes();

    // Map the selected nodes to their data
    const selectedRowData = selectedNodes.map((node) => node.data);

    return selectedRowData;
  }
  assignValues(data) {
    this.kanbanValue = data.kanban;
    this.partValue = data.part;
    this.dockValue = data.llp_dock;
    this.specialistValue = data.EMPLOYEE;
    this.orderlotValue = data.order_lot;
    // this.seqAddress = data.address;
    this.shareValue = data.SHARE;
    this.description = data.part_description;
    this.vanningFrom = data.vanning_from;
    this.vanningTo = data.vanning_to;
    this.lineoffDateFrom = data.lineoff_dt_from;
    this.lineoffDateTo = data.lineoff_dt_to;
    this.inventoryPolice = data.policy_name;
    this.partsControl = data.parts_control;
    // this.partsControlGroup = data.parts_count_group;
    // this.lineSideAddress = data.line_side_address;
    this.pcAddress = data.pc_address;
    this.lifeCycleCode = data.life_cycle;
    this.vehicleCode = data.vehicle_code;
    this.storeRackCapacity = data.store_rack_capacity;
    this.invAdj = 'P';
    this.lifeCycle = data.life_cycle;

    const rawPartsCountGroup = data.parts_count_group;

    if (rawPartsCountGroup) {
      this.partsControlGroup = rawPartsCountGroup.split('|').reverse().join('\n');
    } else {
      this.partsControlGroup = '';
    }
    const rawLineSideAddress = data.line_side_address;

    if (rawLineSideAddress) {
     //#598
     this.lineSideAddress = rawLineSideAddress?.slice(2) || '';

      // let temp_array = rawLineSideAddress.split('|');
      // const prefix = this.selectedDock.dock;

      // temp_array = temp_array.map((str) => {
      //   if (str.startsWith(prefix)) {
      //     return str.slice(prefix.length);
      //   }
      //   return str;
      // });

      // this.lineSideAddress = temp_array.reverse().join('\n');
    } 
    // else {
    //   this.lineSideAddress = '';
    // }
  }

  // setCurrentYearWeek(): void {
  //   const currentDate = new Date();
  //   const currentYear = currentDate.getFullYear();
  //   const startDate = new Date(currentYear, 0, 1);
  //   const days = Math.floor((currentDate.getTime() - startDate.getTime()) / (24 * 60 * 60 * 1000));
  //   const weekNumber = Math.ceil((days + 1) / 7);

  //   // Format the string as "YYYYWK"

  //   this.currentYearWeek = `${currentYear}${weekNumber.toString().padStart(2, '0')}`;
  // }

  clearValues() {
    this.kanbanValue = '';
    this.partValue = '';
    this.dockValue = '';
    this.specialistValue = '';
    this.orderlotValue = '';
    // this.seqAddress = data.address;
    this.shareValue = '';
    this.description = '';
    this.vanningFrom = '';
    this.vanningTo = '';
    this.lineoffDateFrom = '';
    this.lineoffDateTo = '';
    this.inventoryPolice = '';
    this.partsControl = '';
    this.partsControlGroup = '';
    this.lineSideAddress = '';
    this.pcAddress = '';
    this.lifeCycleCode = '';
    this.vehicleCode = '';
    this.storeRackCapacity = '';
    this.invAdj = '';
    this.lifeCycle = '';
  }

  assignWeekDates(inputDateStr) {
    const inputDate = moment(inputDateStr);

    // ISO weeks start on Monday
    const monday = inputDate.clone().startOf('isoWeek');
    const sunday = inputDate.clone().endOf('isoWeek');

    this.lineoff_date_start = monday.format('YYYY-MM-DD');
    this.lineoff_date_end = sunday.format('YYYY-MM-DD');
  }

  // Function to handle the action selection
  onActionSelect(action: any) {
    this.selectedAction = action;
    localStorage.setItem('FromDevan', 'true');

    // Check which action was selected and handle accordingly
    switch (action.action_name) {
      case 'Container Tap':
        this.moveToContainerTap();
        break;
      case 'Devanning History':
        this.moveToDevanHistory();
        break;
      default:
        break;
    }
  }

  moveToContainerTap() {
    this.dataService.sendFilteredData({
      forEdit: false,
      data: null,
      part: this.selectedPartNo.item_id,
      dock: this.selectedDock.dock,
      kanban: this.selectedKanban.kanban,
    });
    this.router.navigate(['inventory/containertap']);
  }
  moveToDevanHistory() {
    this.dataService.sendFilteredData({
      forEdit: false,
      data: null,
      part: this.selectedPartNo?.item_id,
      dock: this.selectedDock?.dock,
      kanban: this.selectedKanban?.kanban,
    });
    this.router.navigate(['inventory/devan-history']);
  }

  async appendprocurementDetails() {
    if (this.orderDetailsForEdit.dock && this.orderDetailsForEdit.kanban && this.orderDetailsForEdit.part) {
      this.selectedDock = {
        dock: this.orderDetailsForEdit.dock, // Adjust if needed
      };
      this.dockChange();

      this.selectedKanban = { kanban: this.orderDetailsForEdit.kanban };
      this.onKanbanChange();

      await this.onSearch(0);
    }
  }


  getSortedPartsControlGroup(): string {
    if (!this.partsControlGroup) return '';
  
    const lines = this.partsControlGroup.split('\n').map(line => line.trim()).filter(Boolean);
  
    const allParts = lines.find(line => line === 'All Parts');
    const others = lines.filter(line => line !== 'All Parts');
  
    return [allParts, ...others].filter(Boolean).join('\n');
  }
  
  
}
